import {React, useEffect} from 'react';

import HomeBanner from '../component/home/home_banner';
import HomeContentPic from '../component/home/home_content-pic';
import HomeContentText from '../component/home/home_content-text';
import HomeContentPicText from '../component/home/home_content-PicText';
import HomeExplore from '../component/home/home_explore';
import TitleCommon from '../component/common/title-common';

import IconWatch from '../img/icon_watch.svg';
import IconListen from '../img/icon_listen.svg';
import IconRead from '../img/icon_read.svg';
import IconBook from '../img/icon_book.svg';
import IconLike from '../img/icon_like.svg';
import PicCheck from '../img/pic_check.svg';

const TitleWatch = [{pic:IconWatch, title:"看" }]
const TitleListen = [{pic:IconListen, title:"聽" }]
const TitleRead = [{pic:IconRead, title:"讀" }]
const TitleBook = [{pic:IconBook, title:"好書推薦" }]
const TitleLike = [{pic:IconLike, title:"名人推薦" }]

function PopupLoginPage(){
    useEffect(() => {
        // Redirect to SSO login page
        const redirectUrl = `${process.env.REACT_APP_SSO_URL}/login?clientId=${process.env.REACT_APP_SSO_CLIENT_ID}`;
        window.location.href = redirectUrl;
    }, []);

    return (
        <div>
            <HomeBanner />
            <div className="container home-content">
                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        {
                            TitleWatch.map(a =>(
                                <TitleCommon
                                    data={a}
                                />
                            ))
                        }
                        <HomeContentPic />
                    </div>
                    <div className="col-lg-4 col-md-6 border-md-right">
                        {
                            TitleListen.map(a =>(
                                <TitleCommon
                                    data={a}
                                />
                            ))
                        }
                        <HomeContentPic />
                    </div>
                    <div className="col-lg-4 col-md-12 border-right border-md-top">
                        {
                            TitleRead.map(a =>(
                                <TitleCommon
                                    data={a}
                                />
                            ))
                        }
                        <HomeContentText />
                    </div>
                    <div className="col-md-6 border-top">
                        {
                            TitleBook.map(a =>(
                                <TitleCommon
                                    data={a}
                                />
                            ))
                        }
                        <HomeContentPicText />
                    </div>
                    <div className="col-md-6 border-top border-right">
                        {
                            TitleLike.map(a =>(
                                <TitleCommon
                                    data={a}
                                />
                            ))
                        }
                        <HomeContentPicText />
                    </div>
                </div>
            </div>
            <HomeExplore />
        </div>
    );
}

export default PopupLoginPage;